import React, { useEffect, useState } from "react";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormLabel, Switch } from "@mui/material";
import { bindActionCreators } from "@reduxjs/toolkit";
import GlobalErrorBoundary from "components/GlobalErrorBoundary";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Company, ReduxState } from "types";
import { usePrevious } from "myParkdUtils/customHooks";
import { FormSource } from "features/company/companyDetails";
import * as companyActions from 'features/company/companyActions';


export const CompanyCarSettingsForm = (props: Props) => {

    const [formSubmitted, setFormSubmitted] = useState(false);

    const { companyUpdateStatus } = props.companyDetails;
    const prevCompanyUpdateStatus = usePrevious(companyUpdateStatus);
    const { supportsGloballyShared } = props.companyDetails.companyDetails;

    const onChange = () => {
        const newCompanyDetails: Company = {
            ...props.companyDetails.companyDetails,
            supportsGloballyShared: !supportsGloballyShared
        }
        props.updateCompanyDetails(newCompanyDetails, FormSource.UPDATE_DRIVER_SETTINGS);
    }

    useEffect(() => {
        if (companyUpdateStatus.formSource === FormSource.UPDATE_DRIVER_SETTINGS &&
            prevCompanyUpdateStatus && prevCompanyUpdateStatus.loading &&
            (companyUpdateStatus.succeeded || companyUpdateStatus.error)
        ) {
            setFormSubmitted(true);
        } else {
            setFormSubmitted(false);
        }
    }, [companyUpdateStatus]);


    return (
        <div className="radius-rectangle settings-box">
            <div className="settings-box-header">
                <h3 className="bold-title">
                    <FontAwesomeIcon icon={faGear} className="icon-before" />
                    <FormattedMessage id="SETTINGS_COMPANY_VEHICLES_SETTINGS" />
                </h3>
            </div>

            <GlobalErrorBoundary className="eb-red-background eb-rounded-corners-bottom">
                <div className="settings-box-content">
                    <div className="flex-center-horizontal">
                        <Switch
                            id="switch-supportsGloballyShared"
                            checked={supportsGloballyShared}
                            onChange={() => onChange()}
                            size="medium"
                            disabled={companyUpdateStatus.loading}
                        />
                        <FormLabel htmlFor="switch-supportsGloballyShared">
                            <FormattedMessage id="SETTINGS_COMPANY_VEHICLES_GLOBALLY_SHARED_LABEL" />
                        </FormLabel>

                    </div>
                    <p><FormattedMessage id="SETTINGS_COMPANY_VEHICLES_GLOBALLY_SHARED_INFO" /></p>

                    {formSubmitted && (
                        <React.Fragment>
                            {companyUpdateStatus.error && (
                                <div className="error-box" style={{ margin: '20px 0 0 0' }}>
                                    <FormattedMessage id='ERROR_SOMETHING_WENT_WRONG' />
                                </div>
                            )}
                            {companyUpdateStatus.succeeded && (
                                <div className="success-box" style={{ margin: '20px 0 0 0' }}>
                                    <FormattedMessage id="SETTINGS_COMPANY_VEHICLES_UPDATE_SUCCEEDED" />
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </GlobalErrorBoundary>
        </div>
    )
}


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;

function mapStateToProps(state: ReduxState) {
    return {
        companyDetails: state.companyDetails,
        token: state.auth.token
    };
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        updateCompanyDetails: companyActions.updateCompanyDetails
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyCarSettingsForm);